var _mask, _path, _path2, _path3, _path4, _mask2, _g, _mask3, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 33,
    fill: "none",
    viewBox: "0 0 28 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "bad-file_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22 2H2v29h24V6l2 2v23a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h18l2 2Z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22 2H2v29h24V6l2 2v23a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h18l2 2Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22 2v2h4.828L23.414.586 22 2ZM2 2V0H0v2h2Zm0 29H0v2h2v-2Zm24 0v2h2v-2h-2Zm0-25 1.414-1.414L24 1.172V6h2Zm2 2h2v-.828l-.586-.586L28 8Zm-8-8 1.414-1.414L20.828-2H20v2Zm2 0H2v4h20V0ZM0 2v29h4V2H0Zm2 31h24v-4H2v4Zm26-2V6h-4v25h4Zm1.414-24.414-2-2-2.828 2.828 2 2 2.828-2.828ZM30 31V8h-4v23h4Zm-4 4a4 4 0 0 0 4-4h-4v4ZM2 35h24v-4H2v4Zm-4-4a4 4 0 0 0 4 4v-4h-4Zm0-29v29h4V2h-4Zm4-4a4 4 0 0 0-4 4h4v-4Zm18 0H2v4h18v-4ZM23.414.586l-2-2-2.828 2.828 2 2L23.414.586Z",
    mask: "url(#bad-file_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "m19.857 1.293 7 7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M18.5 1v8.5H27"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "bad-file_svg__b",
    width: 12,
    height: 5,
    x: 8,
    y: 19,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 24H8v-5h12z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bad-file_svg__b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.188,
    cy: 24,
    r: 4.313,
    stroke: "currentColor",
    transform: "rotate(-180 14.188 24)"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "bad-file_svg__c",
    width: 20,
    height: 3,
    x: 4,
    y: 14,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 14h20v3H4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    mask: "url(#bad-file_svg__c)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.235,
    cy: 13.5,
    r: 2.794
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.765,
    cy: 13.5,
    r: 2.794
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadFile);
export default __webpack_public_path__ + "static/media/bad-file.bf22d515.svg";
export { ForwardRef as ReactComponent };